// extracted by mini-css-extract-plugin
export default {"panel":"PredictionPanel_panel__a-ty5"};